import { toast } from "react-toastify";
import { _AdquisitionItem } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { ITEM_CONSOLIDATOR, ITEM_JEFE, ITEM_PREPARADOR } from "../../../../../../Constants";
import { AdquisitionItem } from "../../../../../../contract/adquisition-setting/AdquisitionItem"
import { useEffect, useState } from "react";

interface componentProp {
    idlnArea: number;
    onChange: Function;
    dataItem: any;
}

export const MisPlanesPreparadorComponentEditor = ({ idlnArea, onChange, dataItem }: componentProp) => {
    const role = ITEM_CONSOLIDATOR;
    const { instance, bean, setBean } = useDataBean(_AdquisitionItem);
    const [paa, setPaa] = useState<any>({});

    useEffect(() => {
        if (idlnArea) {
            getArea();
        }

    }, [idlnArea])

    const getArea = () => {
        instance.getAdquisitionPlanFunctionalID(idlnArea).then(
            (resp) => {
                setBean(resp)
            }
        ).catch(err => { toast.error(err) })
    }



    return (
        <>
            {bean.IDAdquisitionPlanFunctionalID ?
                <div className="row">
                    <div className="col">
                        <AdquisitionItem newItemData={dataItem} selectRow={(e) => { onChange?.(e) }} beanOficina={bean} idAdquisitionPlanFunctionalID={bean.IDAdquisitionPlanFunctionalID} rol={role} />
                    </div>
                </div>
                :
                <div className="d-flex mt-4 justify-content-center">
                    <div className="alert alert-warning" role="alert">
                        <p>
                            Debe seleccionar una <strong>Área / Dependencia</strong> para poder continuar.
                        </p>
                    </div>
                </div>
            }
        </>
    )
}